import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';
import { createPortal } from 'react-dom';
import HoverCopyField from '@/temu-platform/modules/products/components/HoverCopyField';

function skuSizeLabel(sku) {
  return sku?.sizeName || sku?.skuSpecLabel || sku?.specName || sku?.skuSize || '—';
}

function skuMerchantCode(sku) {
  return sku?.supplierSku || sku?.merchantSku || sku?.platformSkuId || '';
}

/**
 * SKC 下全部 SKU 明细弹窗
 */
export default function SkuDetailModal({
  open,
  skc = null,
  onClose,
}) {
  if (!open || !skc) return null;

  const skus = Array.isArray(skc.skus) ? skc.skus : [];
  const stop = (event) => {
    event.stopPropagation();
  };

  return createPortal(
    <div
      className="tpo-sku-modal"
      role="presentation"
      onClick={onClose}
      onKeyDown={(event) => {
        if (event.key === 'Escape') onClose?.();
      }}
    >
      <div className="tpo-sku-modal__backdrop" aria-hidden="true" />
      <div
        className="tpo-sku-modal__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tpo-sku-modal-title"
        onClick={stop}
      >
        <div className="tpo-sku-modal__head">
          <div className="tpo-sku-modal__head-main">
            <h2 id="tpo-sku-modal-title">{fixedUi("SKU 明细")}</h2>
            <p className="tpo-sku-modal__meta">
              {skc.specLabel ? (
                <>
                  <span className="tpo-sku-modal__meta-text">{skc.specLabel}</span>
                  <span className="tpo-sku-modal__meta-sep" aria-hidden="true">·</span>
                </>
              ) : null}
              <HoverCopyField
                label="SKC"
                value={skc.skcId && skc.skcId !== '—' ? skc.skcId : ''}
                separator="："
                className="tpo-sku-modal__meta-copy"
              />
              <span className="tpo-sku-modal__meta-text">共 {skus.length} 个尺码</span>
            </p>
          </div>
          <button type="button" className="tpo-btn tpo-btn--ghost tpo-btn--sm" onClick={onClose}>
            {fixedUi("关闭")}
          </button>
        </div>
        <div className="tpo-sku-modal__body">
          {skus.length === 0 ? (
            <div className="tpo-sku-modal__empty">{fixedUi("暂无 SKU")}</div>
          ) : (
            <table className="tpo-sku-modal__table">
              <thead>
                <tr>
                  <th scope="col">{fixedUi("尺码")}</th>
                  <th scope="col">{fixedUi("商家 SKU")}</th>
                  <th scope="col">{fixedUi("平台 SKU")}</th>
                  <th scope="col">{fixedUi("可用库存")}</th>
                  <th scope="col">{fixedUi("总库存")}</th>
                </tr>
              </thead>
              <tbody>
                {skus.map((sku, idx) => {
                  const merchantCode = skuMerchantCode(sku);
                  return (
                    <tr key={sku?.id || `${skc.key}-${idx}`}>
                      <td>{skuSizeLabel(sku)}</td>
                      <td>
                        <HoverCopyField value={merchantCode} />
                      </td>
                      <td>
                        <HoverCopyField
                          label="SKU"
                          value={sku?.platformSkuId || ''}
                        />
                      </td>
                      <td>{sku?.stockAvailableQty ?? sku?.stockQty ?? '—'}</td>
                      <td>{sku?.stockQty ?? '—'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        <div className="tpo-sku-modal__foot">
          <button type="button" className="tpo-btn tpo-btn--primary tpo-btn--sm" onClick={onClose}>
            知道了
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}

export { skuSizeLabel, skuMerchantCode };
